import type { IdentifiersState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/identifiers';

export const getTravellerContextId = (userIdentifiers: IdentifiersState): string | null => {
  const isUserLoggedInWhenAppInit = userIdentifiers.isLoggedInWhenAppInit === true ? 2 : 1;

  if (userIdentifiers.utid) {
    return `${userIdentifiers.utid};${isUserLoggedInWhenAppInit}`;
  }

  return userIdentifiers.utid;
};
